import { useQuery } from "@tanstack/react-query";
import { getObservationsShadow } from "../api/workers";

/** Options de la lecture shadow d'un worker, communes au hook et aux lectures
 * d'équipe (`useQueries`) pour partager le cache. */
export function observationsShadowQuery(
  workerUrl: string,
  from: string,
  to = from,
  enabled = true,
) {
  return {
    queryKey: ["tawa", "worker", "observations-shadow", workerUrl, from, to],
    queryFn: () => getObservationsShadow({ worker_url: workerUrl, from, to }),
    enabled: enabled && !!workerUrl && !!from && !!to,
    retry: false,
    staleTime: 5 * 60_000,
  };
}

/** Comparaison shadow d'une journée ou d'une période (31 jours au plus) d'un
 * worker. Une erreur (route absente, plage refusée) ne se relance pas. */
export function useObservationsShadow(
  workerUrl: string,
  from: string,
  to = from,
  enabled = true,
) {
  return useQuery(observationsShadowQuery(workerUrl, from, to, enabled));
}
